<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;">
        <div class="img-title">
            <img src="@/assets/tip.png" />
            <span>由版权家为你自行上传的作品进行的版权存证，版权家不对您上传内容的真实性作验证。</span>
        </div>

         <div class="table-list" style="height:auto;min-height: 726px">
        <div class="table-list-title">
            <span style="margin-left:25px">我的存证</span>
            <div class="choose-group">
            <span class="choose-group-span">时间</span>
            <Date-picker @on-change="changeDate" :value="value2" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px"></Date-picker>           
            <span class="choose-group-span">请选择文件类型</span>
            <i-select v-model="model1" placeholder="全部" style="width:126px" @on-change="selectType">
                <i-option v-for="(item,index) in cityList" :key="index" :value="index">{{ item }}</i-option>
            </i-select>
            <div class="father-box-input">
                <input placeholder="请输入作品名称" v-model="name" class="select-input-self" @keyup.enter="addworkname"></input>
                <img @click="addworkname" src="@/assets/search.png" class="search-icon"/>
            </div> 
            <button @click="addworkname" class="btn-84" style="margin-right:30px">查询</button>
            <button @click="gocunzheng" class="btn-84" style="margin-right:30px">新增存证</button>
            </div>
        </div>
        <Row class="table-style-size">
            <i-col span="5">作品名称</i-col>
            <i-col span="4">文件数量</i-col>
            <i-col span="4">存证时间</i-col>
            <i-col span="4">存证证书</i-col>
            <i-col span="7">操作</i-col>
        </Row>
        <div v-if="records.length>0">
            <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">        
                <i-col span="5">
                    <!-- <Tooltip :content="item.orderTitle" placement="top">{{item.orderTitle}}</Tooltip> -->
                    <Tooltip :content="item.orderTitle" placement="top"><span style="display:inline-block;width:230px;height:21px;" class="notwrap">{{item.orderTitle}}</span></Tooltip>
                </i-col>      
                <i-col span="4">{{item.attachmentsNum}}</i-col>
                <i-col span="4">{{item.createDate}}</i-col>
                <i-col span="4"><img :src="item.orderAuditStatus=='cert_sign_issue'?ifDciSuccess:ifFciFail" @click="downBookFinish(item.orderAuditStatus,item.orderSeqNo)" :style="{cursor:item.orderAuditStatus=='cert_sign_issue'?'pointer':'default'}" /></i-col>
                <i-col span="7">
                    <button class="btn-84" @click="goDetails(item.id)" style="margin-right:20px">详情</button>
                    <button v-if="item.orderAuditStatus=='reject_editable'" class="btn-84" @click="goSubmit(item.id)">重新提交</button>   
                    <!-- <button v-if="item.orderAuditStatus=='cert_sign_issue'" class="btn-84" style="margin:0px 20px" @click="downBook(item.orderSeqNo)">下载证书</button>
                    <button v-if="item.orderAuditStatus=='cert_sign_issue'" class="btn-84" @click="downDataBook(item.orderSeqNo)">下载存证包</button> -->
                    <div class="showphotow" v-if="item.orderAuditStatus=='cert_sign_issue'">
                        <button class="btn-84">更多操作</button>
                        <div class="showdiasy">
                            <p @click="openVerify(item.orderSeqNo)">证书核验</p>
                            <p @click="downBook(item.orderSeqNo)">下载证书</p>
                            <p @click="downDataBook(item.orderSeqNo)">下载存证包</p>
                            <p @click="downBcBook(item.orderSeqNo)">下载BC文件</p>
                        </div>
                    </div>               
                </i-col>
            </Row>
            <div class="commont-page" style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
                <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>
        <div class="empty-box" v-if="records.length<=0&&flag">
            <img src="@/assets/empty.png" class="empty-img" />
            <p>表单暂无数据哦～</p>
        </div>
        </div>
    </div>
    
</template>

<script>
    import {getOrderDownCert,getCertFileType} from '@/api/staticPage';
    import Cookies from "js-cookie";
    export default {
        metaInfo: {
            title: '我的存证|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            },{
                name: 'Description',
                content: ''
            }]
        },
        name:'myCert',
        data(){
            return{
                total:0,
                pageSize:8,
                pageNumber:1,
                startDate:'',
                endDate:'',
                name:'',
                attachementsTypes:'',
                value2:[],
                cityList: [],
                model1: 'all',
                records:[],
                ifDciSuccess:require('@/assets/cert-open.png'),
                ifFciFail:require('@/assets/cert-close.png'),
                flag:false,
                pages:0,
                flagType:'f0'
            }
        },
         methods: {
            _getCertFileType(){
                let _this = this;
                getCertFileType().then(res=>{
                    if(res.code == 200){
                    _this.cityList =  Object.assign({'all':'全部'}, res.result)
                    console.log('****************',_this.cityList)
                    }
                })
            },
            gocunzheng(){
                let query = {
                    code:1001
                };
                this.$router.push({ path:'/apply-cert',query: query })
            },
            selectType(val){
                console.log('这是获取的类型',val)
                this.attachementsTypes = val=='all'?'':val;
                this.pageNumber=1;
                this._getOrderDownCert();
            },
            _getOrderDownCert(){
                let _this = this;
                let userInfo = JSON.parse(Cookies.get("userInfo"));
                let params = {
                    pageNumber:_this.pageNumber,
                    pageSize:_this.pageSize,
                    sort:'create_date',
                    order:'desc',
                    startDate:_this.startDate,
                    endDate:_this.endDate,
                    name:_this.name,
                    attachementsTypes:_this.attachementsTypes,
                    registerId:userInfo && userInfo.id?userInfo.id:'',
                }
                getOrderDownCert(params).then((res)=>{
                    console.log('获取的最后的实名状态',res)
                    if(res.code == 200){
                        _this.records = res.result.records
                        _this.total = Number(res.result.total)
                        _this.flag=true;
                        _this.pages = res.result.pages
                    } 
                })
            },
            changeDate(starttime,endtime){
                this.startDate = starttime ? starttime[0]:'';
                this.endDate = starttime ? starttime[1]:'';
                this.pageNumber=1;
                this._getOrderDownCert();
            },
            changepage(index){
                this.pageNumber = index
                this._getOrderDownCert();
            },
            addworkname(){
                this.pageNumber=1;
                this._getOrderDownCert();
            },
            goDetails(id){
                console.log('获取的详情的id',id)
                this.$router.push({
                    path: '/cert-info',
                    query: {
                    id: id
                    }
                })
            },
            goSubmit(id){
                this.$router.push({
                    path: '/apply-cert',
                    query: {
                    id: id
                    }
                })
            },
            downBookFinish(status,id){
                if(status == 'cert_sign_issue'){
                    this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
                        if(res.code == 200){
                            // this.funDownload(res.result)
                            window.open(res.result,'_blank')
                        }
                    })
                }
            },
            downBook(id){
                this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
                    if(res.code == 200){
                        // this.funDownload(res.result)
                        window.open(res.result,'_blank')
                    }
                })
            },
            downDataBook(id){
                console.log( this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id);
                window.open( this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id, '_self');
            },
            downBcBook(id){
                window.open( this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?certificateOrderSeqNos=" + id, '_self');
            },
            //证书核验
            openVerify(val){
                // let routeUrl = this.$router.resolve({
                //     path: "/index/creation_verification",
                //     name:'creationVerification',
                //     params: {type:this.flagType,id:val}
                // });
                // window.open(routeUrl.href, '_blank');
                window.open(this.API_ROOT_UPLOAD +"verification/"+ this.flagType+'/'+val, '_blank');
            },
            funDownload(content) {
                const links = content;
                let aDom = document.createElement("a");
                aDom.target = "_self";
                aDom.href = links;
                aDom.download = links.substr(links.lastIndexOf('/'), links.length);
                aDom.click();
                // 创建隐藏的可下载链接
                // console.log('123456789')
                // var eleLink = document.createElement('a');
                // eleLink.download = content.substring(content.lastIndexOf('/')+1)
                // eleLink.href = content;
                // eleLink.style.display = 'none';
                // // 触发点击
                // document.body.appendChild(eleLink);
                // eleLink.click();
                // // 然后移除
                // document.body.removeChild(eleLink);
                // var form = document.createElement('form');
                // form.action = 'www.baidu.com?id=1';
                // form.target = '_blank';
                // form.method = 'POST';
                // document.body.appendChild(form);
                // form.submit();
            },
        },
        mounted(){
            this._getCertFileType();
            this._getOrderDownCert();
        }
    }
</script>

<style scoped lang="less">
    /deep/ .ivu-select-single .ivu-select-selection{
        height: auto!important;
    }
.showphotow{
    display: inline-block;
    height: 100%;
    position:relative;
    .showdiasy{
      position:absolute;
      top:35px;
      left:0px;
      background: #fff;
      box-shadow: 0 2px 18px 0 rgba(179,189,199,.47);
      border-radius: 4px;
      z-index:777;
      width: 110px;
      display:none;
      p{
        height:30px;
        line-height:30px;
        cursor:pointer;
        font-size: 12px;
        background-color: #fff;
        color: #929292;
      }
      p:hover{
        background-color: #f7f9fb;
        color: #4e4e4e;
      }
    }
    &:hover{
      .showdiasy{
        display:block;
      }
    }
  }
</style>